import { StarOutlineIcon } from './StarOutlineIcon';

/**
 * author: Google
 * id D443AD2F-291D-496E-ACD2-109891446FF2
 * name star-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-outline.svg
 * tags
 * - Shape 
 */
export const StarBorderIcon = StarOutlineIcon;
export default StarBorderIcon